import {computed, Injectable, signal} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private _sidebarState = signal<'close' | 'open'>('close');
  private sidebarStateChanged$ = new BehaviorSubject<string>(this._sidebarState());
  private _editing = signal(false);
  public sidebarStateObservable$ = this.sidebarStateChanged$.asObservable();
  public readonly sidebarState = computed(() => this._sidebarState());
  public readonly editing = computed(() => this._editing());

  constructor() {
    this.sidebarStateChanged$.next('close');
  }

  toggle(): void {
    this._sidebarState.update((prev) => prev === 'open' ? 'close' : 'open');
    if (this._sidebarState() === 'close') {
      this._editing.set(false);
    }
    this.sidebarStateChanged$.next(this._sidebarState());
  }

  setEditing(editing: boolean): void {
    this._editing.set(editing);
  }
}
